module.exports = __webpack_public_path__ + "static/media/persona_2.bf9972c3.png";